import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashNew = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	className: "trash-svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "bin-1"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 1.5,
			y1: 4.5,
			x2: 22.5,
			y2: 4.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.25,1.5H9.75A1.5,1.5,0,0,0,8.25,3V4.5h7.5V3A1.5,1.5,0,0,0,14.25,1.5Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 9.75,
			y1: 17.25,
			x2: 9.75,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 14.25,
			y1: 17.25,
			x2: 14.25,
			y2: 9.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.865,21.124A1.5,1.5,0,0,1,17.37,22.5H6.631a1.5,1.5,0,0,1-1.495-1.376L3.75,4.5h16.5Z"
		})
	]
});
const ForwardRef = forwardRef(SvgTrashNew);
export default ForwardRef;
